import React, { memo } from 'react';
import { StyledIcon } from './styles';
import { IconProps } from './types';

const DEFAULT_DOT_SIZE = 6;
function Dot({ className, fillOpacity, size = DEFAULT_DOT_SIZE }: IconProps) {
  return (
    <StyledIcon
      data-test="carousel-dot"
      className={`${className} carousel-dot`}
      opacity={fillOpacity}
      size={size}
      marginRight={size - 1}
    ></StyledIcon>
  );
}

export default memo(Dot);
